import {Component, Input} from '@angular/core';
import {Avatar} from "primeng/avatar";

@Component({
  selector: 'app-avatar',
  imports: [
    Avatar
  ],
  templateUrl: './avatar.component.html',
  standalone: true,
  styleUrl: './avatar.component.scss'
})
export class AvatarComponent {
  @Input() image: string = '';
  @Input() firstName: string | null = null;
  @Input() lastName: string | null = null;
  readonly avatarColors: string[] = [
    'bg-red-600', 'bg-blue-600', 'bg-green-600', 'bg-yellow-600',
    'bg-indigo-600', 'bg-purple-600', 'bg-pink-600', 'bg-teal-600',
    'bg-orange-600', 'bg-lime-600', 'bg-emerald-600', 'bg-cyan-600',
    'bg-violet-600', 'bg-rose-600', 'bg-amber-600', 'bg-fuchsia-600',
    'bg-sky-600', 'bg-slate-600', 'bg-zinc-600', 'bg-neutral-600'
  ];
  @Input() size: "normal" | "large" | "xlarge" = "large";

  getInitials(firstName?: string | null, lastName?: string | null): string {
    const first = firstName?.charAt(0) || '';
    const last = lastName?.charAt(0) || '';
    return (first + last).toUpperCase();
  }

  getAvatarImage(): string | undefined {
    return this.image || undefined;
  }

  getAvatarLabel(): string | undefined {
    if (!this.image) {
      return this.getInitials(this.firstName, this.lastName);
    }
    return undefined;
  }

  getAvatarColor(): string {
    if (!this.firstName) return 'bg-gray-500';
    const name = this.firstName + this.lastName;
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % this.avatarColors.length;
    return this.avatarColors[index];
  }

}
